/** Tiny query-string helpers shared by the API client and the URL-synced filters. */

export type QsValue = string | number | boolean | null | undefined | Array<string | number>;
export type QsRecord = Record<string, QsValue>;

/** '?a=1&b=2&b=3' (arrays as repeated keys, null/undefined/empty arrays skipped) or '' when nothing is set. */
export function toQueryString(query?: QsRecord): string {
  if (!query) return '';
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value === null || value === undefined) continue;
    if (Array.isArray(value)) {
      for (const item of value) params.append(key, String(item));
    } else {
      params.append(key, String(value));
    }
  }
  const s = params.toString();
  return s ? '?' + s : '';
}

/** Parses '?a=1&b=2&b=3' (or without the '?') into key -> all values, in order. */
export function parseQueryString(search: string): Map<string, string[]> {
  const out = new Map<string, string[]>();
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  params.forEach((value, key) => {
    const list = out.get(key);
    if (list) list.push(value);
    else out.set(key, [value]);
  });
  return out;
}
